import React, { useState } from 'react';
import API from '../../api';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import { FiMonitor } from 'react-icons/fi';

const SecurityTab = () => {
  const { logout } = useAuth();
  const [passwords, setPasswords] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [saving, setSaving] = useState(false);
  const [loggingOutAll, setLoggingOutAll] = useState(false);

  const handleChange = (e) => {
    setPasswords((p) => ({ ...p, [e.target.name]: e.target.value }));
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (passwords.newPassword !== passwords.confirmPassword) {
      toast.error('New passwords do not match');
      return;
    }
    
    setSaving(true);
    try {
      await API.put('/api/auth/security/password', {
        currentPassword: passwords.currentPassword,
        newPassword: passwords.newPassword
      });
      toast.success('Password updated successfully');
      setPasswords({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update password');
    } finally {
      setSaving(false);
    }
  };

  const handleLogoutAll = async () => {
    if (!window.confirm("Are you sure you want to log out of all devices? This will also log you out of your current session.")) return;
    
    setLoggingOutAll(true);
    try {
      await API.post('/api/auth/security/logout-all');
      toast.success('Successfully logged out of all devices');
      // Trigger local logout Since all tokens are considered invalidated or we want to clear them
      logout();
    } catch (err) {
      toast.error('Failed to log out devices');
      setLoggingOutAll(false);
    }
  };

  return (
    <div className="p-6 md:p-8">
      <h2 className="font-playfair text-2xl font-bold text-navy mb-6">Security Settings</h2>
      
      <div className="max-w-2xl space-y-10">
        
        {/* Change Password */}
        <div>
          <h3 className="font-semibold text-lg text-charcoal mb-4 border-b pb-2">Change Password</h3>
          <form onSubmit={handlePasswordSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Current Password</label>
              <input type="password" name="currentPassword" required minLength="6" value={passwords.currentPassword} onChange={handleChange} className="input-field" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
                <input type="password" name="newPassword" required minLength="6" value={passwords.newPassword} onChange={handleChange} className="input-field" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Confirm New Password</label>
                <input type="password" name="confirmPassword" required minLength="6" value={passwords.confirmPassword} onChange={handleChange} className="input-field" />
              </div>
            </div>
            <button type="submit" disabled={saving} className="btn-navy px-6 mt-2 disabled:opacity-50">
              {saving ? 'Updating...' : 'Update Password'}
            </button>
          </form>
        </div>

        {/* Device Sessions */}
        <div>
          <h3 className="font-semibold text-lg text-charcoal mb-4 border-b pb-2">Active Sessions</h3>
          <p className="text-sm text-gray-500 mb-4">
            If you notice any suspicious activity, you can log out of all active sessions across all your devices.
          </p>
          
          <div className="flex items-center justify-between p-4 bg-red-50 border border-red-100 rounded-xl">
             <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-red-100 text-red-500 rounded-full flex items-center justify-center">
                   <FiMonitor size={20} />
                </div>
                <div>
                   <h4 className="font-semibold text-red-700">Log out everywhere</h4>
                   <p className="text-xs text-red-600">Instantly sign out of all browsers and devices.</p>
                </div>
             </div>
             <button onClick={handleLogoutAll} disabled={loggingOutAll} className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-lg transition-colors shadow-sm disabled:opacity-50">
               {loggingOutAll ? 'Executing...' : 'Log Out All'}
             </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default SecurityTab;
